import { useEffect, useState } from "react";
//import UserModelsEnum, { FaqUserTypes } from "../helpers/enums/UserModelsEnum";
//import { useAuth } from '../context/AuthContext';
import { getAllProducts } from "../services/Products";


function useFetchProducts(categoryName) {


    const [filter, setFilter] = useState({stateParam: 'ACTIVE', showRows: 20,categoriesParam: categoryName});
    const [lastPage, setLastPage] = useState(false);
    const [response, setResponse] = useState([]);
    const [loading, setLoading] = useState(true);

   //const [chagedCategorieLinks, setChagedCategorieLinks] = useState(true);

   // const {user} = useAuth();

    const getProducts = async () => {

        setLoading(true);

        //let type;
    
        // if(user.model === UserModelsEnum.Broker || user.model === UserModelsEnum.Developer) {
        //   type = 'SUDO';
        // }
    
        try {

           const res = await getAllProducts({...filter});

          setResponse(res.data);
          if(res.data.empty || res.data.last) setLastPage(true);
        } catch (error) {
          console.error(error);
        } finally{
          setLoading(false);
        }
    
    }



    useEffect(() => {

       getProducts();
    
    }, [filter]);

    return {loading, response, lastPage, filter, setFilter};


}

export default useFetchProducts